const quotasNemuruConstants = {
    scriptsUrl: {
        dev: 'https://cdn.nemuru.com/assets/stg/nemuru.stg.js',
        pro: 'https://cdn.nemuru.com/assets/prod/nemuru.prod.js'
    },
    clientId: {
        dev: '494cfa22-8a95-4318-91e2-9d67870ea542',
        prod: '3ba07320-1833-47e3-9fe6-2d02ced510f1'
    },
    product: 'instalments',
    codesLang: [
        {
            lang: 'es',
            nemuruLang: 'es-ES'
        },
        {
            lang: 'ca',
            nemuruLang: 'ca-CA'
        },
        {
            lang: 'en',
            nemuruLang: 'en-US'
        }
    ]
};

export default quotasNemuruConstants;